export const formatDuration = (seconds) => {
  if (!seconds || seconds <= 0) return null;
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return [h > 0 && `${h}h`, m > 0 && `${m}m`, s > 0 && `${s}s`]
    .filter(Boolean)
    .join(" ");
};
import { format } from "date-fns";

export const formatRelativeTime = (date) => {
  if (!date) return "—";

  const now = new Date();
  const d = new Date(date);
  const diffMs = now - d;
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);

  if (diffSeconds < 60) return `${diffSeconds}s ago`;
  if (diffMinutes < 60) return `${diffMinutes}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffWeeks < 5) return `${diffWeeks}w ago`;
  if (diffMonths < 12) return `${diffMonths}mo ago`;
  return format(d, "MMM d, yyyy");
};
export const SITES_OPTIONS = [
  { value: "allsites", label: "All Sites" },
  { value: "nxmap", label: "NXMap" },
  { value: "nxstart", label: "NXStart" },
  { value: "other", label: "Other" },
];

export const RESPONSES_SITE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "allsites", label: "All Sites" },
  { value: "nxmap", label: "NXMap" },
  { value: "nxstart", label: "NXStart" },
  { value: "other", label: "Other" },
  { value: "sharelink", label: "Share Link" },
];

export const categories = ["common", "environmental", "social", "governance"];
export const QUESTION_TYPES = [
  "text",
  "long_text",
  "single_choice",
  "multiple_choice",
  "yes_no",
  "true_false",
  "rating",
  "scale",
  "number",
  "email",
  "dropdown",
  "custom_dropdown",
  "multiple_dropdown",
  "attachment",
];
export const SURVEY_TYPES = [
  { value: "prospect", label: "Prospect" },
  { value: "intake", label: "Intake" },
  { value: "feedback", label: "Feedback" },
  { value: "assessment", label: "Assessment" },
  { value: "other", label: "Other" },
];

export const SURVEY_STATUSES = [
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "closed", label: "Closed" },
  { value: "expired", label: "Expired" },
  { value: "published", label: "Published" },
];

export const SURVEY_SORT_OPTIONS = [
  { value: "recently_updated", label: "Recently updated" },
  { value: "recently_added", label: "Recently added" },
  { value: "alphabetical", label: "Alphabetical" },
  { value: "most_submissions", label: "Most submissions" },
];
export const RESPONSES_SORT_OPTIONS = [
  { value: "recently_submitted", label: "Recently submitted" },
  { value: "recently_updated", label: "Recently updated" },
  { value: "oldest", label: "Oldest" },
  { value: "alphabetical", label: "Alphabetical" },
];
export const SURVEY_STATUS = {
  active: "active",
};
export const DECISION_OPTIONS = [
  { value: "follow_up", label: "Follow Up" },
  { value: "discard", label: "Discard" },
];
export const RESPONSE_STATUS_OPTIONS = [
  { value: "all", label: "All statuses" },
  { value: "new", label: "New" },
  { value: "in_review", label: "In Review" },
  { value: "resolved", label: "Resolved" },
];
export const PRIORITY_OPTIONS = [
  { value: "all", label: "All priorities" },
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
];
export const SURVEY_TYPE_CONFIG = {
  prospect: {
    label: "Prospect",
    style:
      "bg-blue-50   text-blue-600   border-blue-100   dark:bg-blue-500/10   dark:text-blue-400   dark:border-blue-500/20",
  },
  intake: {
    label: "Intake",
    style:
      "bg-purple-50 text-purple-600 border-purple-100 dark:bg-purple-500/10 dark:text-purple-400 dark:border-purple-500/20",
  },
  assessment: {
    label: "Assessment",
    style:
      "bg-amber-50  text-amber-700  border-amber-100  dark:bg-amber-500/10  dark:text-amber-400  dark:border-amber-500/20",
  },
  feedback: {
    label: "Feedback",
    style:
      "bg-pink-50   text-pink-600   border-pink-100   dark:bg-pink-500/10   dark:text-pink-400   dark:border-pink-500/20",
  },
};
export const PRIORITY_CONFIG = {
  low: {
    label: "Low",
    activeStyle:
      "bg-emerald-50 text-emerald-600 border-emerald-300 dark:bg-emerald-500/20 dark:text-emerald-400 dark:border-emerald-400/50",
    inactiveStyle:
      "bg-white text-emerald-300 border-emerald-300 hover:bg-emerald-50 dark:bg-transparent dark:text-emerald-300 dark:border-emerald-500",
    style:
      "bg-emerald-50 text-emerald-400 border-emerald-100 dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-400/30",
  },
  medium: {
    label: "Medium",
    activeStyle:
      "bg-emerald-200 text-emerald-700 border-emerald-300 dark:bg-emerald-500/30 dark:text-emerald-300 dark:border-emerald-400/50",
    inactiveStyle:
      "bg-white text-emerald-400 border-emerald-400 hover:bg-emerald-60 dark:bg-transparent dark:text-emerald-400 dark:border-emerald-600",
    style:
      "bg-emerald-100 text-emerald-600 border-emerald-200 dark:bg-emerald-500/20 dark:text-emerald-300 dark:border-emerald-400/50",
  },
  high: {
    label: "High",
    activeStyle:
      "bg-emerald-700 text-white border-emerald-800 dark:bg-emerald-600 dark:text-white dark:border-emerald-400/50",
    inactiveStyle:
      "bg-white text-emerald-500 border-emerald-500 hover:bg-emerald-70 dark:bg-transparent dark:text-emerald-500 dark:border-emerald-700",
    style:
      "bg-emerald-700 text-white border-emerald-800 dark:bg-emerald-600 dark:text-white dark:border-emerald-400/50",
  },
};
export const RESPONSES_STATUS_CONFIG = {
  new: {
    label: "New",
    style:
      "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-500/20",
  },
  in_review: {
    label: "In Review",
    style:
      "bg-blue-50     text-blue-600    border-blue-200    dark:bg-blue-500/10    dark:text-blue-400    dark:border-blue-500/20",
  },
  resolved: {
    label: "Resolved",
    style:
      "bg-gray-100    text-gray-600    border-gray-200    dark:bg-gray-700       dark:text-gray-400    dark:border-gray-600",
  },
};
export const DECISION_STATUS_MAP = {
  follow_up: "in_review", // Follow Up → In Review
  discard: "resolved", // Discard   → Resolved
  "": "new", // No decision → New
};
export const DECISION_CONFIG = {
  follow_up: {
    label: "Follow Up",
    activeStyle:
      "bg-emerald-700 text-white border-emerald-800 dark:bg-emerald-600 dark:text-white dark:border-emerald-400/50",
    inactiveStyle:
      "bg-white text-gray-400 border-gray-200 hover:bg-gray-50 dark:bg-transparent dark:text-gray-500 dark:border-gray-700",
    style:
      "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-400 dark:border-emerald-500/20",
  },
  discard: {
    label: "Discard",
    activeStyle:
      "bg-red-500 text-white border-red-600 dark:bg-red-600 dark:text-white dark:border-red-400/50",
    inactiveStyle:
      "bg-white text-gray-400 border-gray-200 hover:bg-gray-50 dark:bg-transparent dark:text-gray-500 dark:border-gray-700",
    style:
      "bg-red-50 text-red-500 border-red-200 dark:bg-red-500/10 dark:text-red-400 dark:border-red-500/20",
  },
};
export const FALLBACK_BADGE =
  "bg-gray-100 text-gray-500 border-gray-200 dark:bg-gray-700 dark:text-gray-400 dark:border-gray-600";
